import { render, staticRenderFns } from "./Categoria_nueva.vue?vue&type=template&id=4c31b65c"
import script from "./Categoria_nueva.vue?vue&type=script&lang=js"
export * from "./Categoria_nueva.vue?vue&type=script&lang=js"
import style0 from "./Categoria_nueva.vue?vue&type=style&index=0&id=4c31b65c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports